export const SMS_RESEND_COOLDOWN_MS = 5 * 60 * 1000; // 5 minutes

const cooldownsByKey = new Map();

export function getSmsResendCooldown(resendCooldownKey, now = Date.now()) {
  if (!resendCooldownKey) {
    return 0;
  }

  const disabledUntil = cooldownsByKey.get(resendCooldownKey) || 0;
  if (disabledUntil && now >= disabledUntil) {
    cooldownsByKey.delete(resendCooldownKey);
    return 0;
  }

  return disabledUntil;
}

export function startSmsResendCooldown(resendCooldownKey, now = Date.now()) {
  const disabledUntil = now + SMS_RESEND_COOLDOWN_MS;
  if (resendCooldownKey) {
    cooldownsByKey.set(resendCooldownKey, disabledUntil);
  }
  return disabledUntil;
}

export function clearSmsResendCooldowns() {
  cooldownsByKey.clear();
}



// WEBPACK FOOTER //
// ./src/common/modals/smsResendCooldown.js